import React from 'react';
import SectionContainer from '../../../../F22/common/SectionContainer';
import FieldRow from '../../../../F22/common/FieldRow';
import { cptSimplificado as cptFn } from '../formulas';

const CPTSimplificadoSection = ({ data, computed }) => {
  return (
    <SectionContainer title="CPT Simplificado" subtitle="Capital Propio Tributario Simplificado al 31.12.2025">
      <div className="f22-subsection">
        <FieldRow label="Capital propio tributario al 01.01.2025" sign="(+)"
          value={cptFn.cptInicial(data)} computed />
        <FieldRow label="Base Imponible ejercicio" sign="(+)"
          value={cptFn.baseImponibleEjercicio(data)} computed />
        <FieldRow label="Total Dividendos percibidos" sign="(+)"
          value={cptFn.dividendosPercibidos(data)} computed />
        <FieldRow label="Retiros del ejercicio, históricos" sign="(-)"
          value={cptFn.retirosHistoricos(data)} computed />
        <FieldRow label="Intereses, reajustes y multas fiscales, históricos" sign="(-)"
          value={cptFn.interesesMultas(data)} computed />
        <FieldRow label="Pago IDPC AT 2025, histórico" sign="(-)"
          value={cptFn.pagoIDPC(data)} computed />
        <FieldRow label="Crédito IPE contra IF del ejercicio" sign="(-)"
          value={cptFn.creditoIPEContraIF(data)} computed />
        <FieldRow label="Incentivo al ahorro art. 14 letra E)" sign="(+)"
          value={cptFn.incentivoAhorro(data)} computed />
        <FieldRow label="Capital Propio Tributario Simplificado" sign="(=)"
          value={computed.cptSimplificado?.cptsPositivoFinal} computed className="f22-field-total" />
      </div>
    </SectionContainer>
  );
};

export default CPTSimplificadoSection;
